module.exports = __webpack_public_path__ + "img/spin_btn.24bb63e8.png";